import { useDialog } from "@platform/store";
import { MarketingDialogTypes } from "@platform/types/platform.types";
import {
  OrgCodeDialogContainer,
  OrgLookupDialogContainer,
} from "@platform/features/invitation";

export function MarketingDialogsContainer() {
  const { activeDialog } = useDialog();

  if (!["code", "orgLookup"].includes(activeDialog || "")) {
    return null;
  }

  switch (activeDialog as MarketingDialogTypes) {
    case "code":
      return <OrgCodeDialogContainer />;
    case "orgLookup":
      return <OrgLookupDialogContainer />;
    default:
      return null;
  }
}
